import type { ReactNode } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

interface PageLayoutProps {
  children: ReactNode;
  title: string;
  description?: string;
  /** Adds top padding to clear the fixed navbar (disable for pages with a full-bleed hero). */
  padded?: boolean;
}

export default function PageLayout({ children, title, description, padded = true }: PageLayoutProps) {
  useDocumentTitle(title, description);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className={`flex-1 ${padded ? "pt-16" : ""}`}>{children}</main>
      <Footer />
    </div>
  );
}